<template>
    <div :ref="refName"
         v-show="appointment.split"
         @click="toggleActivation"
         :class="{ 'appointment': true, 'active': active, 'resizing' : isResizing, 'dragging' : isDragging, 'css-transforms' : useCssTransforms }"
         :style="style">
        <div v-if="active" class="appointment-button position-1" @click="edit">
            <span aria-hidden="true" class="icon icon-info"></span>
        </div>
        <div class="draggable">
            <div class="appointment-customer">
                <div class="appointment-customer-label">
                  <span v-if="appointment.customer">{{ appointment.customer.name }}</span>
                </div>
                <div class="appointment-customer-time">
                  {{ formatMe(value.start) }} - {{ formatMe(value.end) }}
                </div>
            </div>
            <div v-if="value.h >= appointment.tasks.length - 1" class="appointment-line">
                ✓ {{ value.service.name }}
            </div>
        </div>
        <div v-if="active" ref="handle" class="appointment-button resize">
            <span aria-hidden="true" class="icon icon-drag"></span>
        </div>

    </div>
</template>
<script>
  import {
    getControlPosition,
    createCoreData,
    setTopLeft,
    setTopRight,
    setTransformRtl,
    setTransform,
    isTouchDevice,
    formatTime
  } from './utils'
  import TimeTableConst from '@/assets/sass/components/timetable/_variables.scss'
  import auth from '@/auth'
  import UserImage from '@/components/widgets/UserImageWidget'
  import interact from 'interactjs'

  export default {
    name: 'Task',
    props: {
      value: {
        type: Object,
        required: true
      },
      appointment: {
        type: Object,
        required: true
      },
      dragAllowFrom: {
        type: String,
        required: false,
        default: null
      }
    },
    inject: ['eventBus'],
    components: {
      UserImage
    },
    data: function () {
      return {
        currency: auth.getOrganization().currency.toUpperCase(),
        cols: 1,
        rows: Infinity,
        rowHeight: parseInt(TimeTableConst.cellHeight),
        margin: [0, 0],
        draggable: null,
        resizable: null,
        useCssTransforms: true,

        active: false,
        isDragging: false,
        dragging: null,
        isResizing: false,
        resizing: null,
        lastX: NaN,
        lastY: NaN,
        lastW: NaN,
        lastH: NaN,
        style: {},
        rtl: false,

        dragEventSet: false,
        resizeEventSet: false,

        previousH: null,
        previousX: null,
        previousY: null,

        refName: 'task_' + this.value.id,

        preventPopup: false,
        isTouch: false,
        popperOptions: {
          modifiers: {
            flip: {
              enabled: true,
              padding: 140,
              boundariesElement: 'viewport'
            }
          }
        }
      }
    },
    created () {
      // temprorary beecause of v-tooltip problem with flickering
      // this.applyVTooltipPatch()

      let self = this

      self.compactHandler = function () {
        self.createStyle()
      }

      self.directionchangeHandler = (direction) => {
        let d = (document.dir !== undefined) ? document.dir : document.getElementsByTagName('html')[0].getAttribute('dir')
        this.rtl = (d === 'rtl')
        this.createStyle()
      }

      this.eventBus.$on('compactTask', self.compactHandler)
      this.eventBus.$on('directionchange', self.directionchangeHandler)

      this.eventBus.$on('activatedAppointment', self.activateAppointment)
      this.eventBus.$on('deactivatedAppointment', self.deactivateAppointment)

      let direction = (document.dir !== undefined) ? document.dir : document.getElementsByTagName('html')[0].getAttribute('dir')
      this.rtl = (direction === 'rtl')
    },
    beforeDestroy: function () {
      interact('#' + this.refName + '_popover').unset()

      let self = this
      this.eventBus.$off('compact', self.compactHandler)
      this.eventBus.$off('directionchange', self.directionchangeHandler)
    },
    mounted: function () {
      this.cols = this.$parent.employees.length
      this.rows = this.$parent.rows
      this.draggable = this.active
      this.resizable = this.active
      this.createStyle()
      this.isTouch = isTouchDevice()
    },
    computed: {
      maxH () {
        return this.rows - this.value.y
      },
      minH () {
        return 1
      }
    },
    watch: {
      'value.x': function () {
        this.createStyle()
      },
      'value.y': function () {
        this.createStyle()
      },
      'value.h': function () {
        this.createStyle()
      },
      active () {
        this.draggable = this.active
        this.resizable = this.active
      },
      draggable () {
        let self = this
        self.loadInteract()
        if (this.draggable) {
          let opts = {
            restrict: {
              restriction: 'parent'
            },
            autoScroll: true,
            ignoreFrom: '.resize, .split, .info'
          }
          this.interactObj.draggable(opts)
          if (!this.dragEventSet) {
            this.dragEventSet = true
            this.interactObj.on('dragstart dragmove dragend', function (event) {
              self.handleDrag(event)
              event.preventDefault()
            })
          }
        } else {
          this.interactObj.draggable({
            enabled: false
          })
        }
      },
      resizable () {
        let self = this
        self.loadInteract()
        if (this.resizable) {
          let opts = {
            autoScroll: true,
            restrict: {
              restriction: 'parent'
            },
            preserveAspectRatio: false,
            edges: {left: false, right: false, bottom: '.resize', top: false}
          }

          this.interactObj.resizable(opts)
          if (!this.resizeEventSet) {
            this.resizeEventSet = true
            this.interactObj
              .on('resizestart resizemove resizeend', function (event) {
                self.handleResize(event)
                event.preventDefault()
              })
          }
        } else {
          this.interactObj.resizable({
            enabled: false
          })
        }
      },
      cols: function () {
        this.createStyle()
      }
    },
    methods: {
      loadInteract () {
        if (this.interactObj === null || this.interactObj === undefined) {
          this.interactObj = interact(this.$refs[this.refName]).styleCursor(false)
        }
      },
      formatMe (value) {
        return formatTime(value)
      },
      createStyle: function () {
        let x = this.value.x
        let y = this.value.y

        if (x + 1 > this.cols) {
          x = 0
        }

        if (y < 0) {
          y = 0
        }

        let pos = this.calcPosition(x, y, this.value.h)

        if (this.isDragging) {
          pos.top = this.dragging.top

          if (this.rtl) {
            pos.right = this.dragging.left
          } else {
            pos.left = this.dragging.left
          }
        }
        if (this.isResizing) {
          pos.width = this.resizing.width
          pos.height = this.resizing.height
        }

        let style

        if (this.useCssTransforms) {
          if (this.rtl) {
            style = setTransformRtl(pos.top, pos.right, pos.width, pos.height)
          } else {
            style = setTransform(pos.top, pos.left, pos.width, pos.height)
          }
        } else {
          if (this.rtl) {
            style = setTopRight(pos.top, pos.right, pos.width, pos.height)
          } else {
            style = setTopLeft(pos.top, pos.left, pos.width, pos.height)
          }
        }

        style.backgroundColor = this.getColor()
        style.borderColor = this.lightenDarkenColor(this.getColor(), -25)
        this.style = style
      },
      handleResize: function (event) {
        const position = getControlPosition(event)
        // Get the current drag point from the event. This is used as the offset.
        if (position === null) return // not possible but satisfies flow
        const {x, y} = position
        let pos

        const newSize = {width: 0, height: 0}
        switch (event.type) {
          case 'resizestart':
            this.previousH = this.value.h
            let pos = this.calcPosition(this.value.x, this.value.y, this.value.h)
            newSize.width = pos.width
            newSize.height = pos.height
            this.resizing = newSize
            this.isResizing = true
            break
          case 'resizemove':
            const coreEvent = createCoreData(this.lastW, this.lastH, x, y)
            newSize.width = this.resizing.width
            let newHeight = this.resizing.height + coreEvent.deltaY
            newSize.height = newHeight > this.rowHeight ? newHeight : this.rowHeight
            if (newSize.height < this.minH * this.rowHeight) {
              newSize.height = this.minH * this.rowHeight
            }
            this.resizing = newSize
            break
          case 'resizeend':
            pos = this.calcPosition(this.value.x, this.value.y, this.value.h)
            newSize.width = 1
            newSize.height = pos.height
            this.resizing = null
            this.isResizing = false
            break
        }

        // Get new WH
        pos = this.calcHeight(newSize.height)
        pos.w = 1

        // minimal height
        if (pos.h < this.minH) {
          pos.h = this.minH
        }
        if (pos.h > this.maxH) {
          pos.h = this.maxH
        }

        this.lastW = x
        this.lastH = y

        this.value.h = pos.h
        this.value.w = pos.w

        if (this.value.h !== pos.h) {
          this.$emit('resize', this.value, pos.h, pos.w)
        }
        if (event.type === 'resizeend' && (this.previousH !== this.value.h)) {
          this.updatePositions()
          this.merge()

          if (isTouchDevice()) {
            this.active = false
          }

          this.$emit('resizedTask', this.value, pos.h, pos.w, newSize.height, newSize.width)
        }
        this.eventBus.$emit('resizeEventTask', event.type, this.value, pos.h, pos.w)
      },
      handleDrag (event) {
        if (this.isResizing) return

        const position = getControlPosition(event)
        // Get the current drag point from the event. This is used as the offset.
        if (position === null) return // not possible but satisfies flow
        const {x, y} = position

        const newPosition = {top: 0, left: 0}
        switch (event.type) {
          case 'dragstart':
            this.previousX = this.value.x
            this.previousY = this.value.y

            let parentRect = event.target.offsetParent.getBoundingClientRect()
            let clientRect = event.target.getBoundingClientRect()
            if (this.rtl) {
              newPosition.left = (clientRect.right - parentRect.right) * -1
            } else {
              newPosition.left = clientRect.left - parentRect.left
            }
            newPosition.top = clientRect.top - parentRect.top
            this.dragging = newPosition
            this.isDragging = true
            break
          case 'dragend':
            if (!this.isDragging || event.target === null) return

            if (event.target.offsetParent === null) {
              parentRect = {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
              }
            } else {
              parentRect = event.target.offsetParent.getBoundingClientRect()
            }

            clientRect = event.target.getBoundingClientRect()
            if (this.rtl) {
              newPosition.left = (clientRect.right - parentRect.right) * -1
            } else {
              newPosition.left = clientRect.left - parentRect.left
            }
            newPosition.top = clientRect.top - parentRect.top
            this.dragging = null
            this.isDragging = false
            this.preventPopup = true
            break
          case 'dragmove':
            const coreEvent = createCoreData(this.lastX, this.lastY, x, y)
            if (this.rtl) {
              newPosition.left = this.dragging.left - coreEvent.deltaX
            } else {
              newPosition.left = this.dragging.left + coreEvent.deltaX
            }
            newPosition.top = this.dragging.top + coreEvent.deltaY
            this.dragging = newPosition
            break
        }

        let pos
        // Get new XY
        if (this.rtl) {
          pos = this.calcXY(newPosition.top, newPosition.left)
        } else {
          pos = this.calcXY(newPosition.top, newPosition.left)
        }

        this.lastX = x
        this.lastY = y

        this.value.x = pos.x
        this.value.y = pos.y

        if (this.value.x !== pos.x || this.value.y !== pos.y) {
          this.$emit('move', this.value, pos.x, pos.y)
        }
        if (event.type === 'dragend' && (this.previousX !== this.value.x || this.previousY !== this.value.y)) {
          this.updatePositions()
          this.merge()
          this.eventBus.$emit('movedTask', this.value, this.previousX, this.previousY)
        }
        this.eventBus.$emit('dragEventTask', event.type, this.value, this.previousX, this.previousY)
      },
      calcPosition: function (x, y, h) {
        const colWidth = parseInt(TimeTableConst.cellWidth)
        let out
        // add rtl support
        if (this.rtl) {
          out = {
            right: Math.round(colWidth * x + (x + 1) * this.margin[0]),
            top: Math.round(this.rowHeight * y + (y + 1) * this.margin[1]),
            width: Math.round(colWidth + this.margin[0]),
            height: Math.round(this.rowHeight * h + Math.max(0, h - 1) * this.margin[1])
          }
        } else {
          out = {
            left: Math.round(colWidth * x + (x + 1) * this.margin[0]),
            top: Math.round(this.rowHeight * y + (y + 1) * this.margin[1]),
            width: Math.round(colWidth + this.margin[0]),
            height: Math.round(this.rowHeight * h + Math.max(0, h - 1) * this.margin[1])
          }
        }

        return out
      },
      /**
       * Translate x and y coordinates from pixels to grid units.
       * @param  {Number} top  Top position (relative to parent) in pixels.
       * @param  {Number} left Left position (relative to parent) in pixels.
       * @return {Object} x and y in grid units.
       */
      calcXY (top, left) {
        const colWidth = parseInt(TimeTableConst.cellWidth)

        let x = Math.round((left - this.margin[0]) / (colWidth + this.margin[0]))
        let y = Math.round((top - this.margin[1]) / (this.rowHeight + this.margin[1]))

        // Capping
        x = Math.max(Math.min(x, this.cols - 1), 0)
        y = Math.max(Math.min(y, this.rows - this.value.h), 0)

        return {x, y}
      },
      /**
       * Given a height and width in pixel values, calculate grid units.
       * @param  {Number} height Height in pixels.
       * @param  {Number} width  Width in pixels.
       * @return {Object} w, h as grid units.
       */
      calcHeight (height) {
        const colWidth = parseInt(TimeTableConst.cellWidth)

        let w = Math.round(this.margin[0] / (colWidth + this.margin[0]))
        let h = Math.round((height + this.margin[1]) / (this.rowHeight + this.margin[1]))

        // Capping
        w = Math.max(Math.min(w, this.cols - this.value.x), 0)
        h = Math.max(Math.min(h, this.rows - this.value.y), 0)
        return {w, h}
      },
      getColor () {
        let color = this.$parent.employees[this.value.x]['color']
        if (this.appointment.tasks.length && this.appointment.tasks[0].id !== this.value.id) {
          color = this.$parent.employees[this.appointment.tasks[0].x]['color']
        }
        return color
      },
      updatePositions () {
        /*
        let collisions = getAllCollisions(this.$parent.appointments, this.value)
        if (collisions && collisions.length && this.previousX && this.previousY) {
          this.value.x = this.previousX
          this.value.y = this.previousY
          return
        }
        */
        let changed = false
        if (this.previousX !== null && this.previousX !== this.value.x) {
          this.value.employee = this.$parent.employees[this.value.x]

          let updateAppointmentX = true
          let previous
          for (let i in this.appointment.tasks) {
            let current = this.appointment.tasks[i]
            if (previous && previous.x !== current.x) {
              updateAppointmentX = false
            }
            previous = current
          }

          if (updateAppointmentX) {
            this.appointment.x = this.value.x
          }
        }
        if (this.previousY !== null && this.previousY !== this.value.y) {
          changed = true
        }
        if (this.previousH !== null && this.previousH !== this.value.h) {
          changed = true
        }
        if (changed) {
          this.value.start = (this.value.y / 4) + this.$parent.startTime
          this.value.end = this.value.start + (this.value.h / 4)
        }
      },
      merge () {
        let canMerge = true
        let previous
        let totalH = 0
        for (let i in this.appointment.tasks) {
          let current = this.appointment.tasks[i]
          if (previous && ((previous.y + previous.h) !== current.y || previous.x !== current.x)) {
            canMerge = false
          }
          totalH = totalH + current.h
          previous = current
        }

        if (canMerge) {
          this.appointment.y = this.appointment.tasks[0].y
          this.appointment.h = totalH
        }
        this.appointment.split = !canMerge
      },
      edit (e) {
        this.$store.commit('SET_TABLE_SCROLL_POSITION', {
          top: document.scrollingElement.scrollTop,
          left: document.scrollingElement.scrollLeft
        })
        this.$router.push('/organization/appointment/' + this.appointment.id)
        e.preventDefault()
      },
      remove (value) {
        let self = this
        this.$dialog.open({
          title: self.$t('message.areYouSure'),
          message: self.$t('message.removeAppointment'),
          okText: self.$t('button.remove'),
          cancelText: self.$t('button.cancel')
        }).then(response => {
          self.$api.delete('/v1/appointments/' + this.appointment.id).then(() => {
            self.$events.fire('appointment-deleted', {
              appointment: this.appointment.id
            })
            response.close()
          }).catch(error => {
            console.error(error)
            this.$events.fire('message-open', {
              type: 'error',
              message: self.$t('message.somethingWentWrong')
            })
          })
        }).catch(() => {})
      },
      lightenDarkenColor (col, amt) {
        let usePound = false
        if (col[0] === '#') {
          col = col.slice(1)
          usePound = true
        }
        let num = parseInt(col, 16)
        let r = (num >> 16) + amt
        if (r > 255) r = 255
        else if (r < 0) r = 0
        let b = ((num >> 8) & 0x00FF) + amt
        if (b > 255) b = 255
        else if (b < 0) b = 0
        let g = (num & 0x0000FF) + amt
        if (g > 255) g = 255
        else if (g < 0) g = 0
        return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16)
      },
      activateAppointment (appointment) {
        if (this.isResizing || this.isDragging || this.appointment.id !== appointment.id) {
          return
        }
        this.style.backgroundColor = this.lightenDarkenColor(this.getColor(), -30)
      },
      deactivateAppointment (appointment) {
        if (this.isResizing || this.isDragging || this.appointment.id !== appointment.id) {
          return
        }
        this.style.backgroundColor = this.lightenDarkenColor(this.getColor(), 0)
      },
      toggleActivation (e) {
        this.active = !this.active
        if (this.active) {
          this.style.backgroundColor = this.lightenDarkenColor(this.getColor(), -30)
          this.eventBus.$emit('activatedAppointment', this.appointment)
        } else {
          this.style.backgroundColor = this.lightenDarkenColor(this.getColor(), 0)
          this.eventBus.$emit('deactivatedAppointment', this.appointment)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/timetable/Task.vue